import { MessageTypes } from "./EnumsStickers";
import { showToast } from "./Toasts";
export let webSocket;
export let clientID;

export const PayloadTypes = {
    String: "String",
    Int: "Int",
    Float: "Float",
    Bool: "Bool",
    Vector2: "Vector2",
    Vector3: "Vector3",
    JSON: "JSON",
};

export const setupClient = (serverAddress) => {
    webSocket = new WebSocket(serverAddress);
    webSocket.onopen = onOpen;
    webSocket.onclose = onClose;
    webSocket.onmessage = onMessage;
};

const onOpen = (e) => {
    // console.log("Connection opened");
    showToast("Connected to server", "info", 2000);

    sendConnectionMessage();
};

const sendConnectionMessage = () => {
    clientID = localStorage.getItem("clientID");
    
    sendJSONMessage({
        id: "client_connect",
        payloadType: "clientID",
        payload: clientID,
        date: localStorage.getItem("serverDate")
    });
}

const onClose = (e) => {
    console.log("Connection closed");
    showToast("Disconnected from server, please reload", "danger", 20000, true);
};


const onMessage = (e) => {
    const jsonData = JSON.parse(e.data);

    console.log(jsonData);

    switch (jsonData.id) {
        case "client_no_server":
            console.log("No server, need to retry");
            showToast("No game running", "warning", 10000);
            break;
        case "client_connect":
            localStorage.setItem("clientID", jsonData.payload);
            localStorage.setItem("serverDate", jsonData.date);
            
            console.log(`Client connected with ID: ${localStorage.getItem("clientID")}`);
            showToast("Successfully connected", "info", 5000, true);
            break;
        case "server_connect":
            console.log("Unity Connected");
            sendConnectionMessage();
            break;
        case "server_disconnect":
            console.log("Host disconnected");
            showToast("The game disconnected", "danger", 20000, true);
            break;
        case "client_json":
            //const data = JSON.parse(jsonData.payload);
            //TODO: Check data.code and do something
            break;
        default:
            break;
    }
};

export const sendJSONMessage = (data) =>{
    if (webSocket.readyState === 1)
        webSocket.send(JSON.stringify(data));
};

export const sendClientMessage = (data) =>{
    data.clientID = localStorage.getItem("clientID");

    if (webSocket.readyState === 1)
        webSocket.send(JSON.stringify(data));    
};

export const sendPicture = (values) => {
    values.clientID = localStorage.getItem("clientID");
    if (webSocket.readyState === 1)
        webSocket.send(JSON.stringify(values));    
}

export const sendMoveSticker = (values) => {
    if (webSocket.readyState === 1)
        webSocket.send(GetArrayBuffer(values, MessageTypes.MoveSticker));
}

export const sendRotateSticker = (values) => {
    if (webSocket.readyState === 1)
        webSocket.send(GetArrayBuffer(values, MessageTypes.RotateSticker));
}

export const sendScaleSticker = (values) => {
    if (webSocket.readyState === 1)
        webSocket.send(GetArrayBuffer(values, MessageTypes.ScaleSticker));
}

export const sendRandomValuesSticker = (values) => {
    if (webSocket.readyState === 1)
        webSocket.send(GetArrayBuffer(values, MessageTypes.RandomValuesSticker));
}

export const sendValidateSticker = (values) => {
    if (webSocket.readyState === 1)
        webSocket.send(GetArrayBuffer(values, MessageTypes.ValidateSticker));
}



const GetArrayBuffer = (values, messageType) => {
    if (!Array.isArray(values))
        values = [values];

    let buffer = new ArrayBuffer(8 + values.length * 4);

    let intSlot = new Int32Array(buffer, 0, 2);

    let clientIdData = localStorage.getItem("clientID");
    let clientId = parseInt(clientIdData);

    if (clientId === undefined) {
        clientId = -1;
    }

    intSlot.set([messageType, clientId]);

    let floatSlot = new Float32Array(buffer, 8, values.length);
    for (let i = 0; i < values.length; i++)
        floatSlot[i] = values[i];

    return new Uint8Array(buffer).buffer;
}
